// extracted by mini-css-extract-plugin
export var button = "styles-module__button___hXnjf";
export var next = "styles-module__next___zVwKj";
export var previous = "styles-module__previous___N9vmi";
export var river = "styles-module__river___T3seM";
export var riverItem = "styles-module__riverItem___emdyc";
export var riverTrack = "styles-module__riverTrack____B872";
export var slickRiver = "styles-module__slickRiver___Rmg8C";
export var title = "styles-module__title___bYmRW";